import { lazy } from 'react';

const Login = lazy(() => import('../pages/auth/Login.jsx'));
const RegisterPage = lazy(() => import('../pages/auth/RegisterPage.jsx'));
const VerifyEmailOtpPage = lazy(() => import('../pages/auth/VerifyEmailOtpPage.jsx'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/ForgotPasswordPage.jsx'));
const ResetPasswordPage = lazy(() => import('../pages/auth/ResetPasswordPage.jsx'));

const authRoutes = [
  { path: '/login', Component: Login },
  { path: '/register', Component: RegisterPage },
  { path: '/verify-email-otp', Component: VerifyEmailOtpPage },
  { path: '/forgot-password', Component: ForgotPasswordPage },
  { path: '/reset-password', Component: ResetPasswordPage },
];

export default authRoutes;
